import { Component } from 'react';
import PropTypes from 'prop-types';

import { evDynamicBarClick, evDynamicBarImpressionWrapper } from 'events/headerFooter';

import Link from 'components/hf/HFLink';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';
import css from 'styles/components/hf/zappos/dynamicBanner.scss';
import HtmlText from 'components/common/HtmlText';
import { bannerIsDynamicDataEqual, bannerIsStaticDataEqual, getTopBannerData } from 'helpers/HFHelpers';
import { logErrorAndLogToServer } from 'middleware/logger';

class DynamicBanner extends Component {
  componentDidUpdate(prevProps) {
    const { logErrorAndLogToServer, displayPhraseData, hydraHFDynamicBanner } = this.props;
    const topBarBannerData = getTopBannerData(prevProps, prevProps.hydraHFDynamicBanner);
    const nextTopBarBannerData = getTopBannerData(this.props, hydraHFDynamicBanner);

    const isBannerDataEqual = bannerIsStaticDataEqual(topBarBannerData, nextTopBarBannerData) &&
    bannerIsDynamicDataEqual(topBarBannerData, nextTopBarBannerData);

    if (!isBannerDataEqual) {
      const { text, link } = displayPhraseData || {};
      if (text && link) {
        const dynamicBannerContent = {
          contentType: 'DYNAMIC',
          text,
          link
        };

        trackEvent('TE_HEADER_DYNAMICBANNER', null, { l3: JSON.stringify(dynamicBannerContent) });
        track(evDynamicBarImpressionWrapper, { dynamicBannerContent });
      } else if (typeof(displayPhraseData) === 'undefined') {
        const errorMessage = 'WARNING: Dynamic banner data is coming in as empty or undefined.  Investigate and fix this at once!';
        logErrorAndLogToServer(errorMessage);
      }
    }
  }

  render() {
    const { hydraHFDynamicBanner } = this.props;
    const { staticData, dynamicData } = getTopBannerData(this.props, hydraHFDynamicBanner);
    const { testId } = this.context;
    const data = dynamicData || staticData;
    if (!data) {
      return null;
    }

    const { text, link, texts = [], image, alt } = data;
    const bannerContent = dynamicData ? <HtmlText text={text} />
      :
      <>
        <p>
          {texts.map(({ type, copy }) => (type === 'bold' ? <span key={copy} className={css.bold}>{copy}&nbsp;</span> : copy))}
        </p>
        {image && <img src={image} alt={alt}/>}
      </>;

    return (
      <Link
        to={link}
        data-test-id={testId('headerPromo')}
        onClick={() => {
          const dynamicBannerContent = {
            contentType: dynamicData ? 'DYNAMIC' : 'STATIC',
            text: dynamicData ? text : texts.map(({ copy }) => copy).join(' '),
            link,
            imageUrl: image || undefined
          };
          trackEvent('TE_HEADER_DYNAMICBANNERCLICKED', null, { l3: JSON.stringify(dynamicBannerContent) });
          track(evDynamicBarClick, { dynamicBannerContent });
        }}
        className={css.dynamicBanner}>
        {bannerContent}
      </Link>
    );
  }
}

DynamicBanner.defaultProps = {
  logErrorAndLogToServer
};

DynamicBanner.contextTypes = {
  testId: PropTypes.func
};

export default DynamicBanner;
